import AddressFromToCell from '@/components/Reports/Cell/FromToCell.vue'

const config = {
  cellRenderer: AddressFromToCell
}
export default {
  type: 'FromTo',
  config
}
